<template>
  <v-container>
    <v-snackbar
      app
      v-model="show"
      :timeout="sb.timeout"
    >
      <v-icon left v-if="sb.icon">{{sb.icon}}</v-icon>
      {{ sb.text }}

      <template v-slot:action="{ attrs }">
        <v-btn
          color="blue"
          text
          v-bind="attrs"
          @click="show = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>
  </v-container>
</template>

<script>
  export default {
    data(){
      return {
        // show: false
      }
    },
    computed:{
      sb(){return this.$store.getters['market/snackbar']},
      show: {
        get(){return this.sb.show},
        set(openSnackbar){
          if (!openSnackbar) {
            this.$store.commit('market/closeSnackbar')
          }
        }
      }
    }
  }
</script>